import React from 'react';
import {IMultiSelectProps, ISelectProps, MultiSelectInput, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {TableSortDirection} from '~/components/Table';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {sortByString} from '~/lib/sort';
import {fetchDataCubes} from '~/modules/Clients/api';

type ISelectDataCubeProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectDataCube = ({
    disabled,
    ...props
}: ISelectDataCubeProps) => {
    const {resource, isPending} = useResource(() => fetchDataCubes(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && !disabled && <i className='fa fa-spinner fa-spin'/>}
        items={resource}/>;
};

export const SelectDataCubeField = (props: IFieldProps<ISelectDataCubeProps>) => <FormField {...props}>
    <SelectDataCube {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;

type IMultiSelectDataCubesProps = Omit<IMultiSelectProps<ID>, 'items'>;

export const MultiSelectDataCubes = ({
    disabled,
    ...props
}: IMultiSelectDataCubesProps) => {
    const {resource, isPending} = useResource(() => fetchDataCubes(), []);
    return <MultiSelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(resource.map(cube => ({
            label: cube.label,
            value: cube.value
        })), 'label', TableSortDirection.ASC)}/>;
};

export const MultiSelectDataCubesField = (props: IFieldProps<ISelectDataCubeProps>) => <FormField {...props}>
    <MultiSelectDataCubes {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
